import ConfirmStaged from './ConfirmStaged';

export default ConfirmStaged;
